<template>
    <section-layout class="section-prize container">
        <div class="-mt-4 -mt-sm-12 d-flex justify-content-center flex-column align-items-center">
            <div class="d-flex flex-column align-items-start">
                <div class="section-prize__image-wrap">
                    <img src="@/assets/prize.jpg" alt="" class="section-prize__image d-none d-xs1-block shadow"/>
                    <img src="@/assets/prize_mobile.jpg" alt="" class="section-prize__image d-xs1-none"/>
                </div>
                <p class="section-prize__ai-note mt-1 mt-sm-3">Materiał został wygenerowany przy użyciu AI.</p>
            </div>
        </div>
    </section-layout>
</template>

<script>
export default {
    data() {
        return {
            showModal: false,
        };
    },
    methods: {
    },
    components: {
    },
    computed: {
    },
};
</script>
